import { render, staticRenderFns } from "./ToolsBoxPortrait.vue?vue&type=template&id=4ed77bf8&"
import script from "./ToolsBoxPortrait.vue?vue&type=script&lang=js&"
export * from "./ToolsBoxPortrait.vue?vue&type=script&lang=js&"
import style0 from "./ToolsBoxPortrait.vue?vue&type=style&index=0&id=4ed77bf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports